import { useContext } from 'react';
import { AuthContext } from './auth-context';

export function useAuth() {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
}

/**
 * Safe version of useAuth that returns null instead of throwing
 * when used outside of AuthProvider.
 */
export function useAuthSafe() {
  return useContext(AuthContext);
}
